<script>
import {capitalizeText} from "@/baseUtils";
import BaseAvatar from "@/components/BaseAvatar/BaseAvatar.vue";

export default {
  name: "OrganisationSearchItem",
  props: {
    itemData: {
      type: Object
    }
  },
  components: {
    BaseAvatar
  },
  computed: {
    forumImgSrc() {
      return `/viewimage?type=forum&sh=${this.itemData.forum.largeImgHash}`;
    },
    orgTypeText() {
      return capitalizeText(this.itemData.type).replaceAll("_"," ");
    }
  }
}
</script>

<template>
  <div class="organisation-list-item">
    <div class="forum-label">
      <div v-if="itemData.forum.id === 1"
           class="forum-label__icon riksdagen-icon"></div>
      <img v-else :src="forumImgSrc" class="forum-label__icon"/>
      {{itemData.forum.name}}
    </div>
    <div class="org-info">
      <base-avatar class="org-avatar"
                   :img-hash="itemData.organization.largeImgHash"
                   :size="'75'"
      />
      <div class="d-flex flex-direction-column">
        <router-link :to="{name: 'OrganizationView', params: {id: itemData.organization.id}}"
                     target="_blank"
                     class="org-name"
        >{{ itemData.organization.name }}</router-link>
        <div class="org-type">
          <div class="org-type__icon"></div>
          {{orgTypeText}}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.organisation-list-item {
  display: flex;
  margin-bottom: 10px;
  padding: 12px;
  position: relative;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(79, 79, 79, .15);

  .forum-label {
    position: absolute;
    display: inline-block;
    padding: 0 22px 0 0;
    height: 24px;
    line-height: 24px;
    border-right: 1px solid #bbbbbb;
    margin: 0 10px 12px 0;
    background-color: #7835a6;
    color: #fff;
    left: 0;
    top: 12px;
    &:after {
      position: absolute;
      top: 0;
      right: -1px;
      content: '';
      width: 0;
      height: 0;
      border-top: 12px solid transparent;
      border-bottom: 12px solid transparent;
      border-right:12px solid #fff;
    }

    &__icon {
      display: block;
      float: left;
      vertical-align: middle;
      height: 16px;
      width: auto;
      margin: 4px 8px 0 6px;;

      &.riksdagen-icon {
        width: 22px;
        height: 15px;
        background: url("~@/assets/img/proposal/riksdagen-icon.svg"), no-repeat, center;
      }
    }
  }

  .org-avatar {
    margin-right: 15px;
  }

  .org-info {
    display: flex;
    padding-top: 40px;
  }

  .org-name {
    margin: 12px 0 10px;
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
    display: block;
    color: #7835a6
  }

  .org-type {
    display: flex;
    align-items: center;
    font-size: 10px;
    color: #4f4f4f;
    &__icon {
      width: 26px;
      height: 13px;
      margin-right: 3px;
      background: url("~@/assets/img/icon-party-org.svg"), no-repeat, center;
    }
  }
}
</style>